<template>
  <action-person-template :action="action" column="person2" grid="person2" title="Receveur"/>
</template>

<script>
import ActionPersonTemplate from './ActionPersonTemplate'

export default {
  name: 'SportFootballMatchActionPersonReceiver',
  props: {
    action: Object
  },
  components: { ActionPersonTemplate }
}
</script>
